import { useCallback, useContext } from 'react';
import { useTranslations } from 'next-intl';
import { trackTrialEndPopupBookACall, trackTrialStartPopupBookACall, trackUpgradePopupBookACall } from './analytics';
import './paywall-book-demo.css';
import { PaywallContext } from './paywall-context';
import { mapMode } from './paywall-map-mode';

export const PaywallBookDemo = () => {
  const { mode, reason } = useContext(PaywallContext);
  const t = useTranslations('features');

  const onBookACallClick = useCallback(() => {
    switch (mode) {
      case 'upgrade':
        trackUpgradePopupBookACall(reason);
        break;
      case 'trialStart':
        trackTrialStartPopupBookACall(reason);
        break;
      case 'trialEnd':
        trackTrialEndPopupBookACall(reason);
        break;
    }
    window.open(`https://nimbusweb.me/book-a-demo/?ws=webnotes-next_${mapMode[mode]}`, '_blank');
  }, [mode, reason]);

  return (
    <div className="paywall__book-demo rounded-md flex items-center justify-center bg-white p-3">
      <div className="text-base text-center">
        {t.rich('paywall.book_demo', {
          strong: (chunks) => <span className="font-bold">{chunks}</span>,
          link: (chunks) => (
            <span onClick={onBookACallClick} className="text-cyan-900 font-semibold cursor-pointer underline">
              {chunks}
            </span>
          ),
        })}
      </div>
    </div>
  );
};
